'use strict';

const BaseView = require('./base');

class PickerView extends BaseView {
  constructor() {
    super(...arguments);

    this.expandedClassName = 'expanded';
    this.collapsedClassName = 'collapsed';

    this.collection.on('clear', this.clearSelection, this);
    this.collection.on('request', this.clearSelection, this);
    this.model.on(`change:${this.options.selectionName}`, (model, selection) => {
      this.content().options.selection = selection;
      this.render();
    });
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.templateName = 'picker';
    this.renderedEvent = 'rendered';
    this.transitionDuration = 300;
  }

  events() {
    return { 'click .dropdown': 'toggle' };
  }

  className() {
    return `picker glive-picker ${this.collapsedClassName} ${this.styleClassName}`;
  }

  show() {
    this.redraw();
    this.trigger('expand', this);

    const transitionEndHandler = () => this.trigger('expanded', this);
    setTimeout(transitionEndHandler, this.transitionDuration);
    this.$el.removeClass(this.collapsedClassName).addClass(this.expandedClassName);
  }

  hide() {
    this.redraw();
    this.trigger('collapse', this);

    const transitionEndHandler = () => {
      this.trigger('collapsed', this);
      this.$el.addClass(this.collapsedClassName);
    };

    setTimeout(transitionEndHandler, this.transitionDuration);
    this.$el.removeClass(this.expandedClassName);
  }

  toggle() {
    if (this.isVisible()) {
      this.hide();
    } else {
      this.show();
    }
  }

  render() {
    this.container()
      .children()
      .detach();
    super.render(...arguments);
    this.appendContent();
    this.autoSelect();
    this.trigger('rendered');
    return this;
  }

  content() {
    if (!this._content) {
      this._content = new this.contentView({
        collection: this.collection,
        selection: this.getSelection(),
      });

      this._content.on('select', this.select, this);
      this._content.render();
    }
    return this._content;
  }

  autoSelect() {
    if (!this.getSelection() && !this.isSelectable() && this.collection.first()) {
      this.setSelection(this.collection.first());
      this.model.trigger('updatedCollections');
    }
  }

  select(selection) {
    this.setSelection(selection);
    this.render();
    this.trigger('select', selection);
  }

  getSelection() {
    return this.model.get(this.options.selectionName);
  }

  isSelectable() {
    return this.collection.length > 1;
  }

  setSelection(selection) {
    return this.model.set(this.options.selectionName, selection);
  }

  clearSelection() {
    this.setSelection(null);
  }

  container() {
    return this.$el.find('.content');
  }

  appendContent() {
    return this.content().$el.appendTo(this.container());
  }

  isPreviousSelected() {
    if (this.options.previous) {
      return this.options.previous.getSelection();
    } else {
      return true;
    }
  }

  isVisible() {
    return this.$el.hasClass(this.expandedClassName);
  }

  redraw() {
    // this method is used to fix css transitions issues.
    // see http://blog.alexmaccaw.com/css-transitions section "Redrawing"
    return this.$el.get(0).offsetHeight;
  }
}

module.exports = PickerView;
